import React from 'react';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { Dot } from '../../../../../../../../CommonComponents/OPL/Dot/Dot';
import { Text } from '../../../../../../../../CommonComponents/OPL/Text/Text';
import { HtmlTable } from '../../../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import { RothConversionChartDataDTO } from '../../RothConversion.types';
import { formatCurrency } from '../../../../../../../../CommonUtils/formatNumber';
import { SummaryLineName } from './RothConversionTable.constants';

interface Props {
  data: RothConversionChartDataDTO;
}

export const RothConversionTable: React.FC<Props> = ({ data }) => {
  const { maxTaxBracket, summary } = data;

  return (
    <HtmlTable mt="24">
      <table>
        <caption>
          <Box display="flex" alignItems="center">
            Tax Bracket
            {maxTaxBracket && (
              <Box display="flex" alignItems="center" ml="16">
                <Dot bg={maxTaxBracket.color} mr="4" />

                <Text fontWeight={500} color="neutral.600">
                  {maxTaxBracket.value}%
                </Text>
              </Box>
            )}
          </Box>
        </caption>

        <thead>
          <tr>
            <th>
              <Text variant="smallCaps" textAlign="left">
                Name
              </Text>
            </th>
            <th>
              <Box display="flex" alignItems="center" justifyContent="flex-end">
                <Dot bg="primary.300" mr="4" />

                <Text variant="smallCaps">Current</Text>
              </Box>
            </th>
            <th>
              <Box display="flex" alignItems="center" justifyContent="flex-end">
                <Dot bg="primary.500" mr="4" />

                <Text variant="smallCaps">Proposed (With Conversion)</Text>
              </Box>
            </th>
            <th>
              <Text variant="smallCaps" textAlign="right">
                Difference
              </Text>
            </th>
          </tr>
        </thead>

        <tbody>
          {Object.entries(summary).map(([key, { current, recommended, difference }]) => {
            const fontWeight = key === 'totalAssets' ? 600 : 500;

            return (
              <tr key={key}>
                <td>
                  <Text fontWeight={fontWeight}>{SummaryLineName[key]}</Text>
                </td>
                <td>
                  <Text variant="tabular" fontWeight={fontWeight} textAlign="right">
                    {formatCurrency(current)}
                  </Text>
                </td>
                <td>
                  <Text variant="tabular" fontWeight={fontWeight} textAlign="right">
                    {formatCurrency(recommended)}
                  </Text>
                </td>
                <td>
                  <Text
                    variant="tabular"
                    fontWeight={fontWeight}
                    textAlign="right"
                    color={difference < 0 ? 'error.500' : 'inherit'}
                  >
                    {formatCurrency(Math.abs(difference))}
                  </Text>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </HtmlTable>
  );
};
